import { AnimatePresence, motion } from 'motion/react';

import { cn } from '@/lib/utils';

interface VoiceTranscriptProps {
  text: string;
  className?: string;
}

export function VoiceTranscript({ text, className }: VoiceTranscriptProps) {
  return (
    <AnimatePresence mode="wait">
      {text && (
        <motion.p
          key={text.slice(0, 20)}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          aria-live="assertive"
          className={cn(
            'text-center font-mono text-sm text-charcoal-600 dark:text-neutral-400 max-w-md px-6',
            className,
          )}
        >
          {text}
        </motion.p>
      )}
    </AnimatePresence>
  );
}
